export default __webpack_public_path__ + "static/media/back_icon.bf1a377a.svg";